import { ICONS, type IconName } from './icons'

type IconProps = {
  name: IconName
  size?: number
  strokeWidth?: number
  className?: string
}

/**
 * Цвет всегда наследуется (`currentColor`) — иконка красится через CSS родителя, как в макете.
 *
 * `strokeLinecap`/`strokeLinejoin` НЕ задаём намеренно: в макете их нет ни у одной из 113 иконок
 * (проверено грепом), то есть работают браузерные дефолты `butt`/`miter`. Скруглённые концы
 * дали бы заметно другую форму на шевронах и крестиках.
 */
export function Icon({ name, size = 16, strokeWidth = 2, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {ICONS[name]}
    </svg>
  )
}
